import { useTranslation } from 'react-i18next';
import { LANGUAGES, type Language, setLanguage } from '../i18n';

/**
 * Language toggle for the console sidebar.
 *
 * The operator's own team reads Chinese, but a new hire, an auditor or a
 * contractor may not — so the switch is always visible rather than buried in a
 * settings page that does not exist.
 */
export function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage?.startsWith('zh') ? 'zh' : 'en';
  return (
    <fieldset className="flex min-w-0 overflow-hidden rounded-full border border-hairline p-0 text-[10px]">
      <legend className="sr-only">{t('common.language')}</legend>
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          type="button"
          aria-pressed={current === lang.code}
          onClick={() => setLanguage(lang.code as Language)}
          className={`flex-1 px-2 py-1 ${current === lang.code ? 'bg-ink text-white' : 'text-muted'}`}
        >
          {lang.label}
        </button>
      ))}
    </fieldset>
  );
}
